import Step1 from "./Step1"
import Step2 from "./Step2"
import BeneficialOwners from 'components/Demands/BeneficialOwners'
import Step3 from "./Step3"
import Step4 from "./Step4"
import DigitalSignatureTab from 'components/Demands/DigitalSignatureTab'
import ReviewRequestsTab from 'components/Demands/ReviewRequestsTab'
import Step5 from "./Step5"

const tabs = [
    {
        name: "step1",
        display_name: "Détails de la demande",
        component: Step1
    },
    {
        name: "step2",
        display_name: "Client",
        component: Step2
    },
    {
        name:"beneficial-owners-step",
        display_name: 'Bénéficiaires effectifs',
        component: BeneficialOwners
    },
    {
        name: "step3",
        display_name: "Documents",
        component: Step3
    },
    {
        name: "step4",
        display_name: "Commande",
        component: Step4
    },
    {
        name: "digital-signature-step",
        display_name: "Signature électronique",
        component: DigitalSignatureTab
    },
    {
        name: "review-requests-step",
        display_name: "Demandes d'avis",
        component: ReviewRequestsTab
    },
    {
      name:"step5",
      display_name:"Résoudre",
      component:Step5
    }
]

export default tabs

export const moduleName = "treatmentDemandTabs"
export { TAB_ACTIVATION, TAB_ALTERNATIVE_ACTIVATION, TAB_AVAILABLE_INDEXES_SET, TAB_NUMEROTED_SET } from 'store/mutation-types'



// WEBPACK FOOTER //
// ./client/components/Demands/tabs.js